module.exports = __webpack_public_path__ + "static/img/indexTopBg.8c749194.png";